
import { Component, Prop, Vue } from 'vue-property-decorator';
import BoxGridItem from '@/app/components/common/boxGrid/BoxGridItem.vue';

@Component({
  components: {
    BoxGridItem,
  },
})
export default class BoxGridBlock extends Vue {
  @Prop({ default: 'card-block' }) itemClass!: string;

  @Prop({ default: 'managed' }) overlayType!: 'managed' | 'simple';

  private isError = false;

  private isLoading = false;

  get itemClassCalc() {
    return [this.itemClass, { loading: this.isLoading }];
  }
}
